import { apiClient } from '../api/apiClient';

export const socialService = {
    getBatchStats(eventIds) {
        return apiClient.post('social/stats/batch', {
            json: eventIds
        });
    },

    toggleLike(eventId) {
        return apiClient.post('social/likes', {
            json: { eventId }
        });
    },

    getLikes(eventId) {
        return apiClient.get(`social/likes/${eventId}`);
    },

    getComments(eventId) {
        return apiClient.get(`social/comments/${eventId}`);
    },

    addComment(eventId, content) {
        return apiClient.post('social/comments', {
            json: { eventId, content }
        });
    },

    updateComment(commentId, content) {
        return apiClient.put(`social/comments/${commentId}`, {
            json: { content }
        });
    },

    deleteComment(commentId) {
        return apiClient.del(`social/comments/${commentId}`);
    },

    shareResource(entityType, entityId, platform, entityKey = null) {
        return apiClient.post('social/shares', {
            json: { entityType, entityId, entityKey, eventId: entityType === 'event' ? entityId : 0, platform }
        });
    },

    shareEvent(eventId, platform) {
        return this.shareResource('event', eventId, platform);
    },

    shareListing(listingId, platform) {
        return this.shareResource('listing', listingId, platform);
    },

    shareVenue(clubId, platform) {
        return this.shareResource('venue', clubId, platform);
    },

    sharePerk({ clubOfferId, supplierPerkId, offerKey }, platform) {
        const entityKey = offerKey || (supplierPerkId ? `supplier-${supplierPerkId}` : `venue-${clubOfferId}`);
        const entityId = supplierPerkId ? -Math.abs(supplierPerkId) : clubOfferId;
        return this.shareResource('perk', entityId, platform, entityKey);
    }
};
